import React from "react";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
// import Doctorpad from "../../assets/img/doctorpad.png";
// import Demodoc from "../../assets/img/demo-doc-image.png";
// import virtualLogo from "../../assets/img/virtual-psych-logo.png";
// import tick from "../../assets/img/tick.svg";
// import Ios from "../../assets/img/ios-btn.png"
import Andriod from "../../assets/img/android-btn.png"
import calenderImage from "../../assets/img/calendar.png";
import qualityImage from "../../assets/img/quality.png"
import deliverability from "../../assets/img/deliverability.png";
import partnership from "../../assets/img/partnership.png";
import "./overview.scss";

const Overview = () => {
    return (
        <div className="overview">
            <div className="overview-header">
                <Header />
            </div>
            {/* <div className="top-banner inside-banner">
                <div className="container">
                    <div className="tb-content">
                        <h2>
                            See a Psychiatrst Online Today
                        </h2>

                    </div>
                </div>
            </div> */}
            {/* quality care */}
            {/* <div className="container inside-container ins-cont-lft">
                <div className="row clearfix">
                    <div className="col-sm-4  ins-cont-img">
                        <img src={Doctorpad} /></div>
                    <div className="col-sm-8 ins-cont-txt">
                        <h3>Quality Care. The Time & Attention You Deserve.</h3>

                        <p>VirtualPsych is a completely new approach to Mental Health Care. Our doctors and providers provide
                            individualized treatment, so they can give you the time and care you need. Our service is completely online,
                            which means that you get comprehensive, personalized care from anywhere on any device. Your VirtualPsych doctor
                            is your partner in health, long-term.</p>
                    </div>
                </div>
            </div> */}
            {/* flexible appointment */}
            {/* <div className="container inside-container ins-cont-rt">
                <div className="row clearfix">
                    <div className="col-sm-4 ins-cont-img">
                        <img src={Demodoc} /></div>
                    <div className="col-sm-8 ins-cont-txt">
                        <h3>Flexible appointments to meet your schedule.</h3>

                        <p>One of the things our clients appreciate the most, beyond access to world-className psychiatric care, is our
                            flexible scheduling. It can take weeks to see a psychiatrist in the office, but with VirtualPsych, you have your
                            first appointment within a short time frame and then enjoy flexible scheduling that fits your life and mental health care
                            needs.</p>

                        <h3>Virtual Care at the highest quality possible.</h3>

                        <p>We provide HD video streaming so you always have a strong connection with your doctor. We’re also happy to book
                            a phone call instead of a video conference call to offer the most convenience and comfort possible. You will
                            never have to deal with poor-quality audio or video connections</p>
                    </div>
                </div>
            </div> */}
            {/* Individualized Mental Health Care */}
            {/* <div className="grey-container preventative-care">
                <div className="container inside-container inside-center">
                    <div className="row" style={{ marginBottom: "20px" }}>
                        <div className="col-sm-12">
                            <h3 style={{ marginBottom: "10px" }}>Individualized Mental Health Care</h3>
                            <p>A tailored patient-centric approach to mental health treatment.</p>
                        </div>
                    </div>
                    <div className="row clearfix">
                        <div className="col-sm-4">
                            <h4>Register</h4>
                            <p>Registration is simple and we accept a variety of insurance providers.</p>
                        </div>
                        <div className="col-sm-4">
                            <h4>Schedule a visit</h4>
                            <p>Schedule your first appointment within just 24 hours.</p>
                        </div>
                        <div className="col-sm-4">
                            <h4>See a Doctor</h4>
                            <p>Connect with a compassionate psychiatrist by video or phone and get the help you need from the comfort of
                                your home.</p>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className="container compare-doc">
                <h3 style={{ textAlign: "center", marginBottom: "40px", fontWeight: 500 }}>
                    TelaMD is So Different Than Traditional Primary Care
                </h3>

                <div className="row">
                    <div className="col-sm-12 bd-content" style={{ overflowX: "auto" }}>
                        <table className="table text-left" style={{ border: "1px solid #ECECEC" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "520px" }}></td>
                                    <td>
                                        <h4 style={{ opacity: 0.5 }}>
                                            Traditional Mental Health Care Treatment
                                        </h4>
                                    </td>
                                    <td>
                                        <img
                                            src={virtualLogo}
                                            alt="Virtual Psych Logo"
                                            style={{ width: "260px" }}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <h3>The Time and Attention You Deserve</h3>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td># of patients per doctor</td>
                                    <td>
                                        Way too many,&nbsp;<strong>around 2,500.</strong> They see about 25-30 each day.
                                    </td>
                                    <td>
                                        <img src={tick} alt="tick" /> Far fewer,&nbsp;
                                        <strong>less than 600.</strong> About 4x more time for you.
                                    </td>
                                </tr>

                                <tr>
                                    <td>Time with doctor per visit</td>
                                    <td>
                                        Typically only&nbsp;<strong>15 minutes</strong>
                                    </td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Up to 1 hour</strong>, and as often as you need.
                                    </td>
                                </tr>

                                <tr>
                                    <td>Call, text, and video chat</td>
                                    <td>
                                        <strong>Not typically</strong>; usually only one or two options.
                                    </td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Yes</strong>, unlimited
                                    </td>
                                </tr>

                                <tr>
                                    <td>Doctor has time to help with chronic issues & behavior change</td>
                                    <td>
                                        <strong>Unlikely</strong>, given how little time they have.
                                    </td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Yes</strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Ease of communication with Doctor on an ongoing basis</td>
                                    <td><strong>No</strong></td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Yes</strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Retrieves all your medical records from past doctors and hospitals</td>
                                    <td><strong>No</strong></td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Yes</strong>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Doctor really gets to know you</td>
                                    <td>
                                        <strong>Unlikely</strong>, due to time constraints.
                                    </td>
                                    <td>
                                        <img src={tick} alt="tick" />
                                        <strong>Yes</strong>. An ongoing, collaborative relationship with our doctor.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> */}
            {/* VirtualPsych is So Different Than Traditional Primary Care */}

            {/* <div className="container compare-doc">
                <h3 style={{ textAlign: "center", marginBottom: "40px" }}>VirtualPsych is a Completely New Platform for treatment of Mental and Behavioral Health</h3>
            </div> */}
            {/* app banner */}
            {/* <div className="app-bx">
                <div className="app-banner"> </div>
                <div className="container">
                    <div className="app-bnr-cntnt">
                        <h1>Care On The GO</h1>
                        <h4>Download Mobile App</h4>
                        <p>Our mobile app is coming soon! <br />please
                            check in for app release updates.</p>
                        <div className="app-download-link">
                            <a href=""><img src={Ios} alt="" /></a>
                            <a href=""><img src={Andriod} alt="" /></a>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* footer */}
            <div className="telewebmd-services container mt-5">
                <div className="row">
                    {/* Left Column – Contact Form */}
                    <div className="col-lg-4 col-sm-5">
                        <div className="rail block" id="job-search-rail">
                            <div className="padding-10-percent" id="results-rail-desktop-2">
                                <h3 style={{ color: 'white', textAlign: 'center', padding: '10px 0 10px', fontWeight: 600, }}>Get in Touch With Us</h3>
                                <form noValidate>
                                    <div className="form-wrapper" id="DesktopEmployerForm5e51447541e72">
                                        <input className="green-bg" name="organization" placeholder="Organization" required />
                                        <input className="green-bg" name="firstName" placeholder="First name" required />
                                        <input className="green-bg" name="lastName" placeholder="Last name" required />
                                        <input className="green-bg" name="email" placeholder="Email" required />
                                        <input className="green-bg" name="phone" placeholder="Phone" maxLength={14} required />

                                        <select className="green-bg" name="profession">
                                            <option value="">Select Profession</option>
                                            <option value="physician">Physician</option>
                                            <option value="nurse-practitioner">Nurse Practitioner</option>
                                            <option value="physician-assistant">Physician Assistant</option>
                                            <option value="therapist">Therapist</option>
                                            <option value="psychologist">Psychologist</option>
                                        </select>

                                        <select className="green-bg" name="speciality">
                                            <option value="">Select Speciality</option>
                                            <option value="Urgent Care">Urgent Care</option>
                                            <option value="Family Medicine">Family Medicine</option>
                                            <option value="Internal Medicine">Internal Medicine</option>
                                            <option value="Psychiatry">Psychiatry</option>
                                            <option value="Dermatology">Dermatology</option>
                                            <option value="Therapy">Therapy</option>
                                            <option value="Other">Other</option>
                                        </select>

                                        {/* Spinner */}
                                        <div className="spinner" hidden>
                                            <div className="double-bounce1"></div>
                                            <div className="double-bounce2"></div>
                                        </div>

                                        <button type="submit" className="button color-7">
                                            Submit
                                        </button>
                                        <div className="consultantNotified">Consultant notified</div>
                                        <div className="error-message" id="submittedInquiry-errors"></div>

                                        {/* Validation messages */}
                                        <small className="text-danger" hidden>
                                            Please enter a valid email
                                        </small>
                                        <br />
                                        <small className="text-danger" hidden>
                                            Please enter a valid last name
                                        </small>
                                        <br />
                                        <small className="text-danger" hidden>
                                            Please enter a valid email
                                        </small>
                                        <br />
                                        <small className="text-danger" hidden>
                                            Please enter a valid phone
                                        </small>
                                    </div>
                                </form>

                                <div className="contact-us">
                                    <p className="form-subtext">Or text us at:</p>
                                    <a href="https://wa.me/4194108334?text=Thanks%20for%20your%20query%20we%20will%20revert%20shortly">
                                        419-410-8334
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column – Info Blocks */}
                    <div className="col-lg-offset-1 col-lg-7 col-sm-6">
                        <div className="speed-of-right row row-padding">
                            <div className="col-md-12">
                                <h2>Telemedicine Coverage For Facilities</h2>
                            </div>
                        </div>

                        {/* Info Block 1 */}
                        <div className="row row-padding">
                            <div className="col-lg-2 col-md-3 col-xs-4">
                                <img className="image" src={calenderImage} alt="calendar" />
                            </div>
                            <div className="col-lg-7 col-sm-6 col-xs-11">
                                <h3>Telemedicine Coverage With Speed of Light</h3>
                                <p>
                                    We will arrange for your Telemedicine services to be covered in as little as 7 days, possibly quicker
                                    in many instances. That means your facility’s patient care will have no or little disruption.
                                </p>
                            </div>
                        </div>

                        {/* Info Block 2 */}
                        <div className="row row-padding">
                            <div className="col-lg-2 col-md-3 col-xs-4">
                                <img className="image" src={qualityImage} alt="quality" />
                            </div>
                            <div className="col-lg-7 col-sm-6 col-xs-11">
                                <h3>Our Doctors are Checked & Vetted</h3>
                                <p>
                                    We check our Doctors for State Medical License, DEA License, Malpractice History, references &
                                    Criminal Background before granting them active provider status.
                                </p>
                            </div>
                        </div>

                        {/* Info Block 3 */}
                        <div className="row row-padding">
                            <div className="col-lg-2 col-md-3 col-xs-4">
                                <img className="image" src={deliverability} alt="deliverability" />
                            </div>
                            <div className="col-lg-7 col-sm-6 col-xs-11">
                                <h3>Secure HIPAA Compliant Audio Visual Platform</h3>
                                <p>
                                    We provide you with a secure audiovisual platform embedded in our website so that you do not need to
                                    worry about the confidentiality and technological burden of streaming.
                                </p>
                            </div>
                        </div>

                        {/* Info Block 4 */}
                        <div className="row row-padding">
                            <div className="col-lg-2 col-md-3 col-xs-4">
                                <img className="image" src={partnership} alt="partnership" />
                            </div>
                            <div className="col-lg-7 col-sm-6 col-xs-11">
                                <h3>Teaming Up for Success</h3>
                                <p>
                                    Whether you have existing Telemedicine services or are interested in setting up or exploring this
                                    "Virtual" alternative, we will team up with your facility to provide additional technical help, meet
                                    credentialing and staffing needs. Together let us serve the health needs of your community.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default Overview;